<template>
	<div>
		<div class="chart_example" :id="id">

		</div>
	</div>
</template>

<script>

  export default {
    data() {
      return {}
    },
    props: ['id', 'lineItemData', 'lineItemTitle'],
    mounted() {
      let $this = this;
      let id = this.id
      let myChart = this.$echarts.init(document.getElementById(id));
      //   series  循环
      var series = [];
      let name = ['KS', 'CX1', 'CX2']
      let color = ['#4B7EFE', '#29CC97', '#5D7092','#FEC400','#FE3C3C','#8bc34a','#03e9f4','#d9ff07','#673ab7','#e5bfea','#bfbee9'];
      let tData = [
        [90, 50, 39, 50, 120, 82, 80, 39, 50, 120, 82, 80],
        [70, 50, 50, 87, 90, 80, 70, 39, 50, 120, 82, 80],
        [290, 200, 20, 132, 15, 200, 90, 39, 50, 120, 82, 80]
      ];
      let xData = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', ''];
      let lineItem1Data = this.lineItemData;
      let lineItemTitle = this.lineItemTitle;
      let yAxisMax = '10';
      if (lineItem1Data && lineItem1Data.name.length > 0) {
        name = lineItem1Data.name;
        tData = lineItem1Data.tData;
        xData = lineItem1Data.xData;
      }
      if(tData.length > 0){
        let tDataMax = [];
        for(let i = 0; i < tData.length; i++){
          tDataMax.push(Math.max.apply(null, tData[i]));
        }
        let max = Math.max.apply(null, tDataMax);
        let maxStrLen = max.toString().length;
        if (maxStrLen > 1) {
          for (let i = 1; i < maxStrLen; i++) {
            yAxisMax += '0';
          }
        }
      }
      for (var i = 0; i < name.length; i++) {
        series.push({
          name: name[i],
          type: "line",
          symbolSize: 3,//标记的大小，可以设置成诸如 10 这样单一的数字，也可以用数组分开表示宽和高，例如 [20, 10] 表示标记宽为20，高为10[ default: 4 ]
          symbol: 'circle',//标记的图形。ECharts 提供的标记类型包括 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'
          smooth: true, //是否平滑曲线显示
          showSymbol: false, //是否显示 symbol, 如果 false 则只有在 tooltip hover 的时候显示
          areaStyle: {
            normal: {
              color: new $this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: color[i]
              }, {
                offset: 0.8,
                color: 'rgba(255,255,255,0)'
              }], false),
              shadowColor: 'rgba(255,255,255, 0.1)',
              shadowBlur: 10,
              opacity: 0.3,
            }
          },
          itemStyle: {
            normal: {
              color: color[i],
              lineStyle: {
                width: 1,
                type: 'solid' //'dotted'虚线 'solid'实线
              },
              borderColor: color[i], //图形的描边颜色。支持的格式同 color
              borderWidth: 8,//描边线宽。为 0 时无描边。[ default: 0 ]
              barBorderRadius: 0,
              label: {
                show: false,
              },
              opacity: 0.5,
            }
          },
          data: tData[i],
        })
      }

      let option = {
        backgroundColor: "#fff",
        //color: ['#4B7EFE', '#FEC400', '#29CC97'],
        title: [{
          text: lineItemTitle,
          left: '1%',
          top: '4%',
          textStyle: {
            fontSize: '16px',
            fontFamily: 'PingFang SC',
            fontWeight: 400,
            color: 'rgba(51,51,51,1)'
          }
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'line', // 默认为直线，可选为：'line' | 'shadow'
            lineStyle: {
              color: '#57617B'
            }
          }
        },
        legend: {
          // x: '50%',
          bottom: '2%',
          textStyle: {
            color: '#ffd285',
          },
          data: name
        },
        grid: {
          borderWidth: 0,
          left: '5%',
          right: '5%',
          bottom: '12%',
          top: '17%',
          textStyle: {
            color: "#EDEEF0"
          },
          containLabel: true
        },
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#EDEEF0'
            }
          },
          axisTick: { show: false },
          axisLabel: {
            textStyle: {
              color: '#A4A4A4',
              fontSize: '14px',
            }
          },
          boundaryGap: false,
          data: xData,
        },
        yAxis: {
          // max: yAxisMax,
          axisLine: {
            lineStyle: {
              color: '#EDEEF0'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#EDEEF0'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#A4A4A4',
              fontSize: '14px',
            }
          },
          type: 'value'
        },
        series: series
      }
      myChart.setOption(option, true);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener('resize', function () {
        myChart.resize()
      });
    },
    methods: {},
    watch: {},
    created() {
    }
  }
</script>
<style scoped>
	h2 {
		text-align: center;
		padding: 30px;
		font-size: 18px;
	}

	.chart_example {
		height: 450px;
		background: #fff;
		margin: 0 auto;
	}
</style>